<template>
  <mdb-side-nav-2
    v-model="show"
    :data="navigation"
    :over="over"
    @setOffset="togglerOffset = $event"
    v-mdb-resize:start="checkWidth"
  >
    <div slot="header">
      <div class="d-flex flex-center p-2" >
        <img
          :src="require('@/assets/logo.png')"
          class="img-fluid"
          style="height: 150px; width: 150px"
        />
      </div>
    </div>
    <mdb-navbar
      slot="nav"
      position="top"
      color="indigo"
      dark
      :toggler="false"
    >
      <mdb-navbar-nav left>
        <mdb-icon
          :style="{
            paddingLeft: togglerOffset + 'px',
            transition: 'padding-left .3s linear'
          }"
          icon="bars"
          color="dark-grey-text"
          size="lg"
          @click.native="show = !show"
        />
      </mdb-navbar-nav>
      <mdb-navbar-nav class="nav-flex-icons" right>
        <mdb-dropdown tag="li" class="nav-item">
          <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" waves-fixed><mdb-icon icon="user" /> {{this.$store.state.user.name}}</mdb-dropdown-toggle>
          <mdb-dropdown-menu>
            <mdb-dropdown-item @click="changePassword">Change Password</mdb-dropdown-item>
            <mdb-dropdown-item @click="logout">Logout</mdb-dropdown-item>
          </mdb-dropdown-menu>
        </mdb-dropdown>
      </mdb-navbar-nav>
    </mdb-navbar>
    <div slot="main" style="height: 85vh; margin-top: 5rem;">
      <slot></slot>
      <!-- <beautiful-chat
      :participants="participants"
      :titleImageUrl="''"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="true"
      :showFile="true"
      :showEdition="true"
      :showDeletion="true"
      :showTypingIndicator="''"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="{
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }"
      :alwaysScrollToBottom="true"
      :messageStyling="false">
      <template v-slot:header>
        Lapar Admin Chat
      </template>
      <template v-slot:user-avatar="{ message }">
        <div>
          <img style="border-radius: 50px; height: 50px; width: 50px" :src="message.user.imageUrl">
        </div>
      </template>
      <template v-slot:text-message-body="{ message }">
        <div class="font-weight-bold">{{message.user.name}}</div>
        <div>{{message.data.text}}</div>
        <div style="font-size:0.7rem">{{convertTime(message.timestamp)}}</div>
      </template>
      </beautiful-chat> -->
    </div>
  </mdb-side-nav-2>
</template>

<script>
  import {checkPermissionsBinary} from '../js/helper';
  // import Chat from 'vue-beautiful-chat'
  import moment from 'moment';
  import {
    mdbNavbar,
    mdbNavbarNav,
    mdbSideNav2,
    mdbIcon, mdbDropdownItem ,
    mdbDropdown, mdbDropdownMenu, mdbDropdownToggle,
    waves,
    mdbResize
  } from "mdbvue";

  export default {
    name: "DoubleNavigationPagev1",
    components: {
      mdbNavbar,
      mdbDropdownItem,
      mdbNavbarNav,
      mdbSideNav2,
      mdbIcon, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle
    },
    data() {
      return {
        show: true,
        over: false,
        togglerOffset: 0,
        navigation: [],
        chat: null,

        //chat
        icons:{
          open:{
            img: require('@/assets/logo.png'),
            name: 'default',
          },
          close:{
            img: require('@/assets/logo.png'),
            name: 'default',
          },
          file:{
            img: require('@/assets/logo.png'),
            name: 'default',
          },
          closeSvg:{
            img: require('@/assets/logo.png'),
            name: 'default',
          },
        },
        participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
        messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
        newMessagesCount: 0,
        isChatOpen: false, // to determine whether the chat window should be open or closed
      };
    },
    methods: {
      convertTime(date){
        return moment(date).format('DD/MM/YYYY h:mm a');
      },
      checkWidth() {
        this.over = window.innerWidth < 900;
      },
      logout(){
        localStorage.clear();
        window.location.href="/";
      },
      changePassword(){
        this.$router.push({ name: 'change_password' })
      },
      firestoreConfig(){
        var duplicated=false;
        var userRef = this.$firestore.collection("/users");
        this.chat = this.$firestore.collection("/chat");
        userRef.get().then(value=>{
          value.forEach(element => {
            let user = element.data();
            if(user.id==this.$store.state.user.id){
              duplicated=true;
            }
          });
          if(!duplicated){
            userRef.add({...this.$store.state.user, imageUrl: `https://i.pravatar.cc/150?u=${this.$store.state.user.name}`})
            .catch(function(error) {
              console.error("Firestore Error: ", error);
            });
          }
        })
        this.chat.orderBy("timestamp")
          .limitToLast(1)
          .onSnapshot(snapshot=>{
          snapshot.docChanges().forEach(change=>{
            if (change.type === "added") {
              let message={ ...change.doc.data(), user: { ...change.doc.data().user, imageUrl: `https://i.pravatar.cc/150?u=${change.doc.data().user.id}`}};
              if(message.author==this.$store.state.user.name){
                message.author="me";
              }
              this.messageList = [ ...this.messageList, message ];
              this.newMessagesCount=this.newMessagesCount+1;
            }
          });
        });
        this.unsubscribe = this.chat.onSnapshot(function() {});
      },

      //chat method
      onMessageWasSent (_message) {
        let message={ author: this.$store.state.user.name, 
        type: 'text', data: _message.data, timestamp: new Date().valueOf(), 
        id:  this.$store.state.user.name,
        user: this.$store.state.user};
        this.chat.add(message)
        .catch(function(error) {
          console.error("Firestore Error: ", error);
        });
      },
      openChat () {
        // called when the user clicks on the fab button to open the chat
        this.isChatOpen = true
        this.newMessagesCount = 0
      },
      closeChat () {
        this.isChatOpen = false
      },
    },
    mixins: [waves],
    directives: {
      mdbResize
    },
    destroyed: function(){
      // this.unsubscribe();
    },
    mounted: function(){
      let permissions=this.$store.state.permissions;
      this.navigation.push({
        name: "Dashboard",
        icon: "chart-bar",
        to: "/landing"
      })
      if(checkPermissionsBinary(1, permissions)){
        this.navigation.push({
          name: "Orders",
          icon: "file-invoice",
          children: [
            {
              name: "Order Map",
              to: "/active_orders"
            },
            {
              name: "Order Listing",
              to: "/orders"
            },
            {
              name: "Refund Orders",
              to: "/refund_orders"
            },
            {
              name: "Disputed Orders",
              to: "/dispute_order"
            },
            {
              name: "Rider PB Orders",
              to: "/order_partner_attachments"
            },
          ]
        })
      }
      if(checkPermissionsBinary(2, permissions)){
        this.navigation.push({
          name: "Admins Management",
          icon: "user-tie",
          children: [
            {
              name: "Admins",
              to: "/admins"
            },
            {
              name: "Permissions",
              to: "/permissions"
            },
            {
              name: "Roles",
              to: "/roles"
            }
          ]
        })
      }
      if(checkPermissionsBinary(3, permissions)){
        this.navigation.push({
          name: "Users Management",
          icon: "users",
          children: [
            {
              name: "Users",
              to: "/users"
            },
          ]
        })
      }
      if(checkPermissionsBinary(4, permissions)){
        let children=[];
        if(checkPermissionsBinary(16, permissions)){
          children.push({
            name: "Add Merchant",
            to: "/add_merchant"
          })
        }
        if(checkPermissionsBinary(20, permissions)){
          children.push({
            name: "Merchant List",
            to: "/merchant_list"
          })
        }
        if(checkPermissionsBinary(20, permissions)){
          children.push({
            name: "Merchant Map",
            to: "/merchant_map"
          })
        }
        if(checkPermissionsBinary(18, permissions)){
          children.push({
            name: "Merchant Payout",
            to: "/merchant_payout"
          })
        }
        if(checkPermissionsBinary(19, permissions)){
          children.push({
            name: "Merchant Settlement",
            to: "/merchant_settlement"
          })
        }

        if(checkPermissionsBinary(38, permissions)){
          children.push({
            name: "Pending Approve",
            to: "/pending_approve"
          })
        }
        
        this.navigation.push({
          name: "Merchants Management",
          icon: "utensils",
          children: children
        })
        
      }
      if(checkPermissionsBinary(5, permissions)){
        let children=[];
        if(checkPermissionsBinary(33, permissions)){
          children.push({
            name: "Add Rider",
            to: "/add_partner"
          })
        }
        if(checkPermissionsBinary(34, permissions )){
          children.push({
            name: "Rider Online",
            to: "/partner_online"
          })
        }
        if(checkPermissionsBinary(35, permissions)){
          children.push({
            name: "Rider List",
            to: "/partner_list"
          })
        }
        if(checkPermissionsBinary(36, permissions)){
          children.push({
            name: "Rider Payout",
            to: "/partner_payout"
          })
        }
        if(checkPermissionsBinary(37, permissions)){
          children.push({
            name: "Rider Collection",
            to: "/partner_collection"
          })
        }
        if(checkPermissionsBinary(35, permissions)){
          children.push({
            name: "Rider Wallet",
            to: "/partner_wallet"
          })
        }
        if(checkPermissionsBinary(35, permissions)){
          children.push({
            name: "Rider Transactions",
            to: "/partner_wallet_transactions"
          })
        }
        if(checkPermissionsBinary(35, permissions)){
          children.push({
            name: "Rider Transaction Summary",
            to: "/partner_wallet_transaction_summary"
          })
        }
        if(checkPermissionsBinary(35, permissions)){
          children.push({
            name: "Rider Withdrawal",
            to: "/partner_wallet_withdrawal"
          })
        }
        this.navigation.push({
          name: "Riders Management",
          icon: "motorcycle",
          children: children
        })
      }
      if(checkPermissionsBinary(21, permissions)){
        let children=[];
        if(checkPermissionsBinary(31, permissions)){
          children.push({
            name: "Add Promo Code",
            to: "/add_promotion"
          })
        }
        if(checkPermissionsBinary(32, permissions)){
          children.push({
            name: "Promotions List",
            to: "/promotion_list"
          })
        }
        children.push({
          name: "Add Cashback",
          to: "/add_cashback"
        })
        children.push({
          name: "Cashback Lists",
          to: "/cashback_list"
        })
        this.navigation.push({
          name: "Promotion Management",
          icon: "percentage",
          children: children
        })
      }
      if(checkPermissionsBinary(7, permissions)){
        let children=[];
        if(checkPermissionsBinary(41, permissions)){
          children.push({
            name: "App Version Control",
            to: "/app_version_control"
          })
        }
        if(checkPermissionsBinary(42, permissions, )){
          children.push({
            name: "Main Screen Configuration",
            to: "/app_configuration"
          })
        }
        if(checkPermissionsBinary(43, permissions)){
          children.push({
            name: "Zone Coverage",
            to: "/zone_coverage"
          })
        }
        children.push({
            name: "Admin Notification",
            to: "/admin_order_status_notification"
          })
        this.navigation.push({
          name: "App Config",
          icon: "tools",
          children: children
        })
      }
      if(checkPermissionsBinary(6, permissions)){
        let children=[];
        if(checkPermissionsBinary(6, permissions)){
          children.push({
            name: "Report Weekly Banking",
            to: "/weekly_banking"
          })
          children.push({
            name: "Report Service Calls",
            to: "/report_service_calls"
          })
          children.push({
            name: "Report Service Compensate Codes",
            to: "/report_service_compensate_codes"
          })
          children.push({
            name: "Report Rider Daily Performance",
            to: "/report_partner_daily"
          })
        }
        children.push({
          name: "Generated Document",
          to: "/generated_documents"
        })
        this.navigation.push({
          name: "Reports",
          icon: "chart-line",
          children: children
        })
      }
      // this.firestoreConfig();
    }
  };
</script>

<style scoped>
  .navbar i {
    cursor: pointer;
    color: white;
  }
</style>